module.exports = new __parcel__URL__("pages-preview-dark.db4817b0.svg").toString();